;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/belege/:id\",\"regex\":\"^/belege/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/materialanfrage/:id\",\"regex\":\"^/materialanfrage/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false},{\"path\":\"/projekte/:id\",\"regex\":\"^/projekte/([^/]+)$\",\"paramNames\":[\"id\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/artikelsuche\"},{\"path\":\"/belege\"},{\"path\":\"/einstellungen\"},{\"path\":\"/favoriten\"},{\"path\":\"/informationen\"},{\"path\":\"/kontowechsel\"},{\"path\":\"/login\"},{\"path\":\"/materialanfrage\"},{\"path\":\"/projekte\"},{\"path\":\"/projekte/neu\"},{\"path\":\"/register\"},{\"path\":\"/register/confirm\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "16.0.11";import * as Sentry from '@sentry/nextjs';

// Browser DSN must be public (inlined at build time) — use NEXT_PUBLIC_*.
// Fallback ist das crm-documents-client-Projekt (/5) auf sentry.mamasys.com.
const dsn =
  process.env.NEXT_PUBLIC_SENTRY_DSN ||
  'https://cdc2f1b44493d1dd57165b9449fdead8@sentry.mamasys.com/5';

Sentry.init({
  dsn,
  environment:
    process.env.NEXT_PUBLIC_SENTRY_ENVIRONMENT ||
    process.env.NODE_ENV ||
    'development',

  // Tunnel AKTIV — der Browser-SDK POSTet seine Envelopes same-origin an
  // /monitoring (Route-Handler src/app/monitoring/route.ts), der sie serverseitig
  // an sentry.mamasys.com weiterleitet. Umgeht Ad-/Tracking-Blocker, die direkte
  // Requests an …/api/<id>/envelope/?sentry_key=… blockieren.
  tunnel: '/monitoring',

  integrations: [
    Sentry.browserTracingIntegration(),
    // Session Replay — Texte im Klartext sichtbar, NUR Formular-Eingaben werden
    // maskiert (z.B. Passwörter, eingegebene Kundendaten). Medien sind sichtbar.
    Sentry.replayIntegration({
      maskAllText: false,
      maskAllInputs: true,
      blockAllMedia: false,
    }),
    // Feedback-Formular ("Fehler melden") mit deutschen Labels.
    // autoInject: false → KEIN schwebender Button. Das Formular wird manuell
    // aus dem Konto-Menü heraus geöffnet (siehe components/layout/error-feedback.ts).
    Sentry.feedbackIntegration({
      autoInject: false,
      colorScheme: 'system',
      isEmailRequired: true,
      showBranding: false,
      formTitle: 'Fehler melden',
      nameLabel: 'Name',
      namePlaceholder: 'Ihr Name',
      emailLabel: 'E-Mail',
      emailPlaceholder: 'ihre@email.de',
      messageLabel: 'Beschreibung',
      messagePlaceholder: 'Was ist passiert? Was haben Sie erwartet?',
      isRequiredLabel: '(Pflichtfeld)',
      submitButtonLabel: 'Absenden',
      cancelButtonLabel: 'Abbrechen',
      confirmButtonLabel: 'Bestätigen',
      addScreenshotButtonLabel: 'Screenshot hinzufügen',
      removeScreenshotButtonLabel: 'Screenshot entfernen',
      successMessageText: 'Danke für Ihr Feedback!',
    }),
  ],

  // Leichtes Tracing
  tracesSampleRate: 0.1,

  // Session Replay: aktuell wird JEDE Session aufgezeichnet (100 %),
  // bei Fehlern ohnehin (Texte/Medien sind maskiert, s.o.).
  // TODO: für Produktion ggf. wieder herabsetzen (z.B. 0.1), um Volumen zu sparen.
  replaysSessionSampleRate: 1.0,
  replaysOnErrorSampleRate: 1.0,

  // ---- Datenschutz (DSGVO) ----
  sendDefaultPii: false,
});

// TEMP DIAG: Start-Event bei jedem Laden, um zu sehen, ob überhaupt etwas im
// Sentry-Projekt ankommt. Nach erfolgreichem Debuggen wieder entfernen.
Sentry.captureMessage('crm-documents-client gestartet (browser)', 'info');

// Instruments client-side navigations (App Router) for tracing.
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
